/**
 * "To guarantee your shoot": call the creative before booking them.
 *
 * Choosing a creative books a person who has not confirmed anything yet, so the
 * client is told to check availability with them first, as the legacy booking
 * card did. Shown while the list is open, so it stays in view once a creative
 * is picked.
 */

import React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { SystemMessage } from 'components/common/SystemMessage'

export const CreativeGuaranteeNote: React.FC = () => {
  const { t } = useTranslation(['purchase_flow_revamp'])

  return (
    <Box data-cy="pf-revamp-creative-guarantee-note">
      {/* SystemMessage parses the <br /> between the two steps. */}
      <SystemMessage
        variant="info"
        title={t('purchase_flow_revamp:instructions.ct_booking.guarantee_title')}
        message={t('purchase_flow_revamp:instructions.ct_booking.guarantee_text')}
      />
    </Box>
  )
}
